import '@scripts/common/common';

// Кнопка «скопировать ссылку» в блоке «Поделиться постом»
document.querySelectorAll('.blog-share__copy').forEach((box) => {
    const button = box.querySelector('.blog-share__copy-btn');
    if (!button) return;

    button.addEventListener('click', async () => {
        try {
            await navigator.clipboard.writeText(box.dataset.copy);
            button.classList.add('is-copied');
            setTimeout(() => button.classList.remove('is-copied'), 1500);
        } catch (error) {
            // старые браузеры без Clipboard API — выделяем ссылку, дальше вручную
            const range = document.createRange();
            range.selectNodeContents(box.querySelector('.blog-share__url'));
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
        }
    });
});
